import React, { forwardRef } from 'react';

import MUICircularProgress, {
  CircularProgressProps as MUICircularProgressProps,
} from '@material-ui/core/CircularProgress';

interface CircularProgressProps extends MUICircularProgressProps {}

const CircularProgress = forwardRef<unknown, CircularProgressProps>(
  (props, ref) => {
    return <MUICircularProgress {...props} ref={ref} />;
  }
);

CircularProgress.displayName = 'CircularProgress';

export default CircularProgress;
